module.exports = __webpack_public_path__ + "img/logo.5c110c93.png";